import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DepotsCard from './components/DepotsCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const ProgramacaoMain = () => {
  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Início' },
              { name: 'Programação' },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <DepotsCard />
        </Col>
      </Row>
    </Container>
  );
};

export default ProgramacaoMain;
